<script>
    import Notification from "./Notification.svelte";
    import { dismissToast, alert } from "../../js/alert.js";
</script>

<div class="notifications">
    {#each $alert as item (item.id)}
        <Notification id={item.id} type="{item.type}" title="{item.title}" on:delete={(e) => { dismissToast(e.detail.id) }}>{item.text}</Notification>
    {/each}
</div>

<style>
    .notifications {
        position: fixed;
        right: 0;
        top: 0;
        width: 25rem;
        max-width: 100%;
        height: fit-content;
        z-index: 1005;
        padding: 1.25rem;
        user-select: none;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        pointer-events: none;
    }
    @media (max-width: 575.98px) {
        .notifications {
            padding: 0.625rem;
        }
    }
</style>